export enum PaymentProcess {
  inprogress = 'inprogress',
  success = 'success',
  fail = 'fail',
}

export enum PaymentActionType {
  method = 'pay-method',
  onetime = 'onetime',
}

export enum BillingType {
  Annually = 'Annually',
  Monthly = 'Monthly',
  Daily = 'Daily',
}

export enum PaymentType {
  Billing = 'Billing',
  Manual = 'Manual',
}

export enum ProductTier {
  Lite = 'Lite',
  Pro = 'Pro',
  Trial = 'Trial',
}

export enum ProductType {
  OneTime = 'OneTime',
  Subscription = 'Subscription',
}

export enum PaymentTransactionStatus {
  APPROVED = 'APPROVED',
  BILLING_FAILED = 'BILLING_FAILED',
  BILLING_SUCCEED = 'BILLING_SUCCEED',
  CANCELED = 'CANCELED',
  PARTIAL_CANCELED = 'PARTIAL_CANCELED',
  FAILED = 'FAILED',
  PREPARE = 'PREPARE',
  REJECTED = 'REJECTED',
}

export enum BillingStatusType {
  Live = 'Live',
  Quit = 'Quit',
}

export enum CancelReason {
  DataIssue = 'DataIssue',
  NoLongerNeeded = 'NoLongerNeeded',
  Other = 'Other',
  PriceIssue = 'PriceIssue',
  SwitchedService = 'SwitchedService',
}

export enum TrialInfoType {
  preRegistration = 'preRegistration',
  coupon = 'coupon',
}
